<template>
  <div class="new-guide-step-1">
    <form-item label="事件选择">
      <div class="event-model-cont">
        <div class="event-model-item">
          <div class="event-model">
            <div class="event-model-index">A</div>
            <t-select
              ref="eventRef"
              v-model="localEventModel.eventName"
              placeholder="请选择"
              filterable
              class="event-model-select"
              @change="handleChangeEventName"
            >
              <t-option
                v-for="item in eventList"
                :key="item.id"
                :label="item.eventShowName"
                :value="item.eventName"
              ></t-option>
            </t-select>
            <t-select
              v-model="localEventModel.targetColumnModel.type"
              filterable
              placeholder="请选择"
              class="event-model-type-select"
              :disabled="!localEventModel.eventName"
            >
              <t-option label="总次数" value="totalCount" />
              <t-option label="天数" value="totalDays" />
              <t-option label="小时数" value="totalHours" />
            </t-select>
            <t-button @click="handleAddFilterItem" class="btn-filter" variant="outline">
              <icon name="add" slot="icon"></icon>
              筛选项
            </t-button>
          </div>

          <div
            class="filter"
            style="padding: 10px 0 10px 20px; background-color: #fafafa"
            v-if="localEventModel.conditionModelList.length"
          >
            <ConditionFilter
              :filter-type.sync="localEventModel.connectors"
              :filter-list="localEventModel.conditionModelList"
              :condition-operator-options="conditionOperatorOptions"
              :condition-property-options="conditionPropertyOptions"
              :filter-events="localEventModel.eventName"
            />
          </div>
        </div>
      </div>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

export default {
  name: 'EventModel',
  components: {
    FormItem,
    ConditionFilter,
  },
  model: {
    prop: 'eventModel',
    event: 'change',
  },
  props: {
    eventModel: {
      type: Object,
      default: () => {
        return {
          eventName: '',
          connectors: 'and',
          conditionModelList: [],
          targetColumnModel: {
            type: '',
          },
        };
      },
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,

      localEventModel: lodash.cloneDeep(this.eventModel),
    };
  },
  watch: {
    eventModel: {
      handler() {
        if (JSON.stringify(this.eventModel) !== JSON.stringify(this.localEventModel)) {
          this.localEventModel = lodash.cloneDeep(this.eventModel);
        }
      },
      deep: true,
    },
    localEventModel: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localEventModel));
      },
      deep: true,
    },
  },
  methods: {
    handleChangeEventName() {
      this.localEventModel.targetColumnModel.type = '';
    },
    handleAddFilterItem() {
      if (this.localEventModel.conditionModelList.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localEventModel.conditionModelList.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },
  },
};
</script>

<style lang="less">
.modal {
  border-radius: 4px;

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang="less" scoped>
@import './event-model.less';
</style>
